import axios from 'axios';
import { appConfig } from '../../../tools/AppConfig';

const COUNTRY_URL = appConfig.getServerUrl();


export const getInvoice = (
    invoiceToken
  ) => {
    return axios
      .get(`${COUNTRY_URL}/invoice2/${invoiceToken}`)
      .then((res) => res)
      .catch((err) => err.response);
  };

export const getInstallments = (
    integrationId,
    paymentToken,
    offerId
  ) => {
    if(offerId){
      return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/offer_installments`, {
        "integration_id":integrationId,
        "payment_token": paymentToken,
        "offer_id": offerId
      })
      .then((res) => res)
      .catch((err) => err.response);
    }
    else{
      return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/installments`, {
        "integration_id":integrationId,
        "payment_token": paymentToken
      })
      .then((res) => res)
      .catch((err) => err.response);
    }
  };
  export const payForsa = (
    phone,
    downPayment,
    categoryId,
    planId,
    invoiceToken,
    integrationId,
    userData,
    deliveryData
  ) => {
    return axios
      .post(`${COUNTRY_URL}/invoice2/${invoiceToken}`, {
        
            "source": {
                "identifier": phone,
                "selected_plan": categoryId,
                "tenure": planId,
                "down_payment": downPayment,
                "subtype": "FORSA_ONLINE"
            },
            "shipping_data": {
                "apartment": "",
                "email": userData['order_email'],
                "floor": deliveryData.floor || "NA",
                "first_name": userData['order_full_name'].split(' ')[0],
                "street": userData['shipping_street'],
                "building": deliveryData.building || "NA",
                "phone_number": userData['order_phone'],
                "postal_code": deliveryData.postal_code || "NA",
                "city": userData['shipping_city'],
                "country": userData['shipping_country'],
                "last_name": userData['order_full_name'].split(' ')[1],
                "state": deliveryData.state || "NA",
                "extra_description": ""
            },
            "token": invoiceToken,
            "integration_id": integrationId
        
      })
      .then((res) => res)
      .catch((err) => err.response);
  };

  export const sendOTP = (otp, token, reference) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/submit_loan`, {
        otp: otp,
        payment_token: token,
        reference: reference,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  
  export const reSendOTP = (token, reference) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/resend_otp`, {
        reference: reference,
        payment_token: token,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };


